import React from 'react';
import { Box, Typography, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './PreviewPaused.css';

// Format date to display day, month and date
const formatDate = dateString => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

// Format time from datetime string
const formatTimeFromDateTime = dateString => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  let formattedHour = hours;
  let period = 'AM';

  if (hours >= 12) {
    period = 'PM';
    if (hours > 12) {
      formattedHour = hours - 12;
    }
  }

  if (hours === 0) {
    formattedHour = 12;
  }

  return `${formattedHour}:${minutes} ${period}`;
};

const PreviewPaused = ({ open, onClose, session }) => {
  if (!session) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="preview-modal-title"
      className="oneonone-preview-modal"
    >
      <Box className="oneonone-preview-modal-content">
        <Box className="oneonone-preview-modal-header">
          <Typography variant="h6" className="oneonone-preview-title">
            Preview Paused Sessions
          </Typography>
          <IconButton onClick={onClose} className="oneonone-close-button" aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className="oneonone-preview-modal-body">
          <Box className="oneonone-preview-section">
            <Typography className="oneonone-section-title">Paused Session Period</Typography>
            <Box className="oneonone-section-content oneonone-days-time-section">
              <Box className="oneonone-day-row">
                <Typography className="oneonone-day-name">Start</Typography>
                <Box className="oneonone-time-slots-container">
                  <Box className="oneonone-time-slot">
                    {formatDate(session.start)} at {formatTimeFromDateTime(session.start)}
                  </Box>
                </Box>
              </Box>
              <Box className="oneonone-day-row">
                <Typography className="oneonone-day-name">End</Typography>
                <Box className="oneonone-time-slots-container">
                  <Box className="oneonone-time-slot">
                    {formatDate(session.end)} at {formatTimeFromDateTime(session.end)}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default PreviewPaused;
